module.exports = __webpack_public_path__ + "img/gmoScrn1.3e6f75cc.png";